// extracted by mini-css-extract-plugin
module.exports = {"privacy_policy_page":"PrivacyPolicyPage_privacy_policy_page__Ln6pD","lang_toggle_container":"PrivacyPolicyPage_lang_toggle_container__21isS"};